import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { UpdateProductInput } from "../../../__generated__/globalTypes";
import { UPDATE_PRODUCT } from "../products.queries";
import { parseParams } from "../../../helpers/clean-object";
import {
  UpdateProductMutation,
  UpdateProductMutationVariables,
} from "../../../__generated__/UpdateProductMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
  onError: (msg: string) => any;
}

export const useUpdateProduct = ({ id, onCompleted, onError }: IProps) => {
  const form = useForm<UpdateProductInput>({
    mode: "all",
  });

  const [mutate, { loading }] = useMutation<
    UpdateProductMutation,
    UpdateProductMutationVariables
  >(UPDATE_PRODUCT);

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateProduct?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateProduct?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
      onError(error.message);
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
